<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>

					<p>
						{{ microcopy?.summary }}
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form class="w-100" @submit.prevent>
			<div class="rounded-container">
				<div class="row">
					<div class="col rounded-container__btn-col d-flex flex-column" v-html="microcopy?.mainContent"></div>
				</div>
			</div>
			<div class="row btm-btn-group m-auto mb-5">
				<div class="col text-center d-flex flex-column align-items-center">
					<GenericButton
						@button-click="handleClick"
						:label-text="buttonText"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import GenericButton from '@/shared/components/GenericButton.vue';
import router from '../router/index.js';
import { mapState, mapStores } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';


export default {
	data() {
		return {
			microcopy: ''
		}
	},
	components: {
		GenericButton,
	},
	computed: {
		...mapStores(useAppointmentReferralStore),
		...mapState(useAppointmentReferralStore, ['existingCustomer']),
		buttonText() {
			return this.microcopy?.nextButtonLabel;
		},
		nextPage() {
			return 'success';
		},
	},
	methods: {
		handleClick() {
			router.push('your-financial-adviser');
		},
	},
	mounted() {
		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.educationBeforeYouBook;
		document.title = this.microcopy?.metaTitle
	}
};
</script>
